var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9982 0.83374C34.9319 0.83374 0.848877 34.9167 0.848877 76.9831C0.848877 119.049 34.9319 153.132 76.9982 153.132C119.065 153.132 153.148 119.049 153.148 76.9831C153.148 34.9167 119.065 0.83374 76.9982 0.83374ZM76.9982 30.3109C91.921 30.3109 104.019 42.4088 104.019 57.3316C104.019 72.2545 91.921 84.3524 76.9982 84.3524C62.0754 84.3524 49.9775 72.2545 49.9775 57.3316C49.9775 42.4088 62.0754 30.3109 76.9982 30.3109ZM76.9982 135.937C58.9742 135.937 42.8231 127.77 32.0148 114.996C37.7875 104.127 49.087 96.6345 62.2596 96.6345C62.9966 96.6345 63.7335 96.7574 64.4397 96.9723C68.4314 98.2619 72.6074 99.091 76.9982 99.091C81.3891 99.091 85.5957 98.2619 89.5567 96.9723C90.263 96.7574 90.9999 96.6345 91.7368 96.6345C104.909 96.6345 116.209 104.127 121.982 114.996C111.173 127.77 95.0223 135.937 76.9982 135.937Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.df21c3dd00629c449df00850a2071733.svg";
export { ForwardRef as ReactComponent };